import { useState, useEffect } from 'react'
import api, { getFileUrl } from '../utils/api'
import '../styles/contactsPage.css'

interface Contact {
  id: string
  email: string
  prenom?: string
  nom?: string
  statut?: string
  photoUrl?: string
}

interface ContactsPageProps {
  onContactSelect: (contact: Contact) => void
  onClose: () => void
}

export default function ContactsPage({ onContactSelect, onClose }: ContactsPageProps) {
  const [contacts, setContacts] = useState<Contact[]>([])
  const [filteredContacts, setFilteredContacts] = useState<Contact[]>([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const userEmail = localStorage.getItem('userEmail')

  useEffect(() => {
    loadContacts()
  }, [])

  useEffect(() => {
    // Filtrer les contacts
    if (searchTerm.trim() === '') {
      setFilteredContacts(contacts)
    } else {
      const term = searchTerm.toLowerCase()
      setFilteredContacts(
        contacts.filter(contact =>
          (contact.prenom?.toLowerCase().includes(term) ||
            contact.nom?.toLowerCase().includes(term) ||
            contact.email.toLowerCase().includes(term))
        )
      )
    }
  }, [searchTerm, contacts])

  const loadContacts = async () => {
    try {
      setLoading(true)
      const response = await api.get('/api/contacts', {
        params: {
          email: userEmail
        }
      })
      const contactsList = Array.isArray(response.data) ? response.data : []
      setContacts(contactsList)
      setFilteredContacts(contactsList)
    } catch (err: any) {
      console.error('Erreur lors du chargement des contacts:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleContactClick = (contact: Contact) => {
    onContactSelect(contact)
    onClose()
  }

  return (
    <div className="contacts-page-overlay">
      <div className="contacts-page">
        <div className="contacts-header">
          <h2>Sélectionnez un contact</h2>
          <button className="btn-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="contacts-search">
          <input
            type="text"
            placeholder="Rechercher un contact..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </div>

        <div className="contacts-list">
          {loading ? (
            <div className="loading">Chargement des contacts...</div>
          ) : filteredContacts.length === 0 ? (
            <div className="empty-state">
              {contacts.length === 0
                ? 'Aucun contact disponible'
                : 'Aucun contact ne correspond à votre recherche'}
            </div>
          ) : (
            filteredContacts.map((contact) => (
              <div
                key={contact.email}
                className="contact-item"
                onClick={() => handleContactClick(contact)}
              >
                <div className="contact-avatar">
                  {contact.photoUrl ? (
                    <img src={getFileUrl(contact.photoUrl)} alt={contact.prenom || contact.email} onError={(e) => { (e.target as HTMLImageElement).src = 'https://via.placeholder.com/40?text=Contact'; }} />
                  ) : (
                    <span>{(contact.prenom?.[0] || contact.email[0]).toUpperCase()}</span>
                  )}
                </div>
                <div className="contact-info">
                  <h4>{contact.prenom} {contact.nom}</h4>
                  <p>{contact.email}</p>
                </div>
                <span className={`contact-status ${contact.statut}`}>
                  {contact.statut === 'online' ? '🟢' : '⚫'}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
